// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:55.049Z
// Property: The Pavilion (ID: 6767906449167338)
// Collections: 19 amenities, 16 floorplans (live), 20 photos, 34 POIs, 7 reviews, 1 virtual tours, 5 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167338",
  "property_external_id": "100160119",
  "property_zillow_url": "https://www.zillow.com/apartments/hanceville-al/the-pavilion-at-college/CkB9Wg/",
  "property_apartments_url": "https://www.apartments.com/the-pavilion-hanceville-al/lywt3xe/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Pavilion/data=!4m2!3m1!1s0x0:0x935df55348fe05db?sa=X&ved=1t:2428&hl=en&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-pavilion",
  "property_name": "The Pavilion",
  "property_website_url": "https://www.thepavilionatcollege.com/",
  "property_domain": "https://www.thepavilionatcollege.com/",
  "property_address": "401 College Dr NE",
  "property_full_address": "401 College Dr NE, Hanceville, AL 35077",
  "property_address_1": "401 College Dr NE",
  "property_address_2": null,
  "property_address_city": "Hanceville",
  "property_address_state": "AL",
  "property_address_zip_full": null,
  "property_address_zip": "35077",
  "property_address_country": "US",
  "property_address_county": "Cullman County",
  "property_neighborhood_address": "Alabama North Area",
  "property_address_latitude": "34.0695818",
  "property_address_longitude": "-86.7721158",
  "property_email": null,
  "property_phone": "(938) 800-8264",
  "property_call_tracking_phone": "855-758-2607",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to The Pavilion in Hanceville, AL, where spacious living meets convenience. Choose from one, two, or three-bedroom floor plans with modern amenities, including a pet park, grilling area, and maintenance-free lifestyle. Embrace community living just a block from campus. Your ideal home awaits—schedule a tour today!",
  "property_long_description": "Welcome to The Pavilion, Hanceville, AL’s premier apartment community, ideally located just one block from campus for your convenience. Offering spacious one, two, and three-bedroom floor plans, The Pavilion is designed to cater to your modern lifestyle with an abundance of amenities that ensure a maintenance-free living experience. \n\nEnjoy a quick stroll to the pet park, where your furry friends can play freely, or unwind in our beautifully landscaped picnic and grilling areas with family and friends. Our dedicated laundry facility makes everyday chores a breeze, and surface lot parking provides hassle-free access to your home. \n\nStep inside your new apartment and be greeted by stylish hard surface flooring, an equipped kitchen featuring sleek all-black appliances, and ample closet space, including double closets for extra storage needs. Enjoy comfort all year round with ceiling fans and cozy window coverings that enhance your living experience. Each floor plan is thoughtfully designed to maximize space and comfort, ensuring you feel right at home.\n\nConveniently managed by a professional team, The Pavilion prioritizes your satisfaction with top-notch service and a community-oriented atmosphere. Whether you’re a student, a professional, or simply seeking a new space to call home, The Pavilion offers a welcoming environment that suits all lifestyles.\n\nDon’t miss out on the opportunity to elevate your living experience. Find your new home today—browse our availability or schedule a tour to visit our vibrant community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d796f-f6e5-71c8-ba93-27b5f8db0719.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a brick apartment building with balconies and external staircases.",
    "public_id": "019d796f-f6e5-71c8-ba93-27b5f8db0719",
    "storage_key": "property/6767906449167338/019d796f-f6e5-71c8-ba93-27b5f8db0719.webp",
    "width": 1500,
    "height": 955
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "142",
  "property_year_built": "1994",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.36619718309859",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$200.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "70",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed. Maximum 2 pets per unit. Monthly pet rent: $70 per cat or dog.",
  "property_petpolicy_info": "\nPet Policy\nPet Types: Cats & Dogs\n\nBreed Restrictions Apply",
  "property_online_leasing_url": "https://thepavilionaxia.prospectportal.com/Hanceville/The Pavilion",
  "property_resident_portal_url": "https://thepavilionaxia.residentportal.com/auth",
  "property_apply_now_url": "https://thepavilionaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160119/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54ff-455e-74ba-ad14-2ba4149b48f6.webp",
  "property_primary_logo_media": {
    "alt_text": "The Pavilion at College Drive logo",
    "public_id": "019d54ff-455e-74ba-ad14-2ba4149b48f6",
    "storage_key": "property/6767906449167338/019d54ff-455e-74ba-ad14-2ba4149b48f6.webp",
    "width": 250,
    "height": 80
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d745e-44b1-755e-99dc-d01216f672e9.webp",
  "property_secondary_logo_media": {
    "alt_text": "Property management company logo",
    "public_id": "019d745e-44b1-755e-99dc-d01216f672e9",
    "storage_key": "property/6767906449167338/019d745e-44b1-755e-99dc-d01216f672e9.webp",
    "width": 2577,
    "height": 2388
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019df43b-e550-7781-824c-e7c33d128c02.webp",
  "property_fav_icon_media": {
    "alt_text": "The letter P in a dark blue color.",
    "public_id": "019df43b-e550-7781-824c-e7c33d128c02",
    "storage_key": "property/6767906449167338/019df43b-e550-7781-824c-e7c33d128c02.webp",
    "width": 32,
    "height": 32
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54ff-70dd-74af-9321-2e37e03b9a68.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54ff-70dd-74af-9321-2e37e03b9a68",
    "storage_key": "property/6767906449167338/019d54ff-70dd-74af-9321-2e37e03b9a68.webp",
    "width": 250,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54ff-649c-765c-b3aa-b0c963fa02fd.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54ff-649c-765c-b3aa-b0c963fa02fd",
    "storage_key": "property/6767906449167338/019d54ff-649c-765c-b3aa-b0c963fa02fd.webp",
    "width": 250,
    "height": 80
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": "#00306b",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "350 - 1175",
  "property_sqft_min": "350",
  "property_sqft_max": "1175",
  "property_price_range": "$856 - $1438",
  "property_price_min": "856",
  "property_price_max": "1438",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/thepavilionapts/",
  "property_instagram_url": null,
  "property_twitter_url": "https://x.com/thepavilionapts",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJp0tHE6m3iYgR2wX-SFP1XZM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/college-park-apartments-hanceville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Pavilion",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Ideal Apartment Home",
  "property_home_amenities_blurb": "Welcome to The Pavilion in Hanceville, AL, where spacious one, two, and three-bedroom layouts meet modern living. Just a block from campus, enjoy our lush grounds, pet park, and inviting picnic areas. Experience a maintenance-free lifestyle complemented by professional management and all the comforts you deserve. ",
  "property_home_floorplans_blurb": "Welcome to The Pavilion in Hanceville, AL, where your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to every lifestyle. Ready to elevate your living experience? Browse our available apartment homes and find the perfect fit for you!",
  "property_home_gallery_blurb": "Welcome to The Pavilion in Hanceville, AL, where modern comforts meet vibrant community living. With spacious floor plans, a serene pet park, and lush landscaping just a block from campus, you'll find the perfect blend of convenience and relaxation. Picture yourself enjoying the grilling area and maintenance-free lifestyle!",
  "property_home_neighborhood_blurb": "At The Pavilion in Hanceville, AL, find your ideal home with spacious one, two, and three-bedroom floor plans. Enjoy vibrant community life surrounded by cultural gems like the Evelyn Burrow Museum and Wallace State Community College, alongside outdoor retreats at CW Day Park and Veterans Memorial Park. Unlock the best of local living!",
  "property_home_reviews_blurb": "At The Pavilion in Hanceville, AL, residents rave about their vibrant community, praising it as \"a place where neighbors become friends.\" Experience comfort and connection in every corner. See what our residents have to say about living at our community and join a lifestyle you’ll love!",
  "property_neighborhood_blurb": "Experience vibrant living at The Pavilion in Hanceville, AL, where convenience meets community. With spacious one, two, and three-bedroom floor plans, you'll feel right at home. Enjoy nearby attractions like Wallace State Community College, the Evelyn Burrow Museum, and serene parks, creating a perfect blend of relaxation and recreation. ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Pavilion in Hanceville, AL, where spacious one, two, and three-bedroom floor plans meet exceptional amenities. Just a block from campus, enjoy our lush landscaping, pet park, and inviting grilling areas. Experience a maintenance-free lifestyle with professional management, modern kitchens, and ample closet space. Your perfect home awaits!",
  "property_applynow_blurb": "At The Pavilion in Hanceville, AL, immerse yourself in spacious one, two, and three-bedroom apartments designed with your comfort in mind. Enjoy a vibrant community with a pet park, grilling area, and lush landscaping, all just one block from campus. Start your maintenance-free lifestyle—lease your new home online today!",
  "property_contactus_blurb": "At The Pavilion in Hanceville, AL, choose from thoughtfully designed one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Embrace comfort and modern living in a vibrant community. Have questions? Contact our leasing team today to find your ideal home at The Pavilion!",
  "property_faqs_blurb": "At The Pavilion in Hanceville, AL, find your ideal sanctuary with our thoughtfully designed one, two, and three-bedroom floor plans. Whether you're seeking cozy intimacy or spacious comfort, we’ve got you covered. Dive into our FAQs to uncover all you need to know about our vibrant community.",
  "property_floorplans_blurb": "At The Pavilion in Hanceville, AL, tailored living awaits you. Choose from one, two, or three-bedroom floor plans designed with your comfort in mind. Each layout offers a unique space to call home. Browse our available apartment homes and envision the lifestyle you've always wanted!",
  "property_gallery_blurb": "At The Pavilion in Hanceville, AL, picture yourself in spacious, stylish apartments just a block from campus. Enjoy modern amenities like a pet park, a grilling area, and professional management. With floor plans from one to three bedrooms, your maintenance-free lifestyle awaits amidst lush landscaping and thoughtful designs.",
  "property_interactivemap_blurb": "Welcome to The Pavilion in Hanceville, AL – your ideal home just a block from campus! Offering spacious one-, two-, and three-bedroom layouts, our community features lush landscaping, a pet park, grilling and picnic areas, and convenient amenities. Use our interactive community map to find your perfect apartment today!",
  "property_pets_blurb": "At The Pavilion, we know that home isn't complete without your furry companions. Our pet-friendly apartment community welcomes up to two pets per residence, providing the space and amenities that make them feel just as at home as you do. With a dedicated on-site pet park, walks and playtime are always just steps away. Please feel free to contact us for full details regarding pet fees, monthly rent, and any additional questions you may have.",
  "property_referafriend_blurb": "At The Pavilion in Hanceville, AL, living well is a shared experience! Our diverse floor plans—featuring one, two, and three-bedroom options—are designed for comfort and style. Great friends make great neighbors; refer a friend to join our vibrant community today and enjoy the countless memories you'll create together!",
  "property_residentaccess_blurb": "Welcome to The Pavilion in Hanceville, AL, where your comfort meets convenience. Our diverse floor plans—one, two, and three bedrooms—cater to all lifestyles. For residents, our portal makes managing your home a breeze. Log in now to pay rent, schedule maintenance, and enjoy seamless living at its best!",
  "property_reviews_blurb": "At The Pavilion in Hanceville, AL, residents rave about the tight-knit community and modern amenities, saying, \"It's like living in a resort every day!\" Join our vibrant neighborhood and see what our residents have to say about their experiences at our welcoming community! Your perfect home awaits.",
  "property_created_at": "1775247379195",
  "property_scheduletour_blurb": "Experience the charm of The Pavilion in Hanceville, AL, where spacious one, two, and three-bedroom floor plans await. Whether you’re seeking a cozy retreat or room to grow, our community has it all. Schedule a tour today, and hear firsthand why our residents love calling this place home!",
  "property_thankyou_blurb": "Thank you for your interest in The Pavilion in Hanceville, AL! Choose from our stylish one, two, or three-bedroom floor plans, each designed for comfort and modern living. Our team will reach out soon to help you explore your perfect home and answer any questions you may have.",
  "property_virtualtours_blurb": "At The Pavilion in Hanceville, AL, our thoughtfully designed one, two, and three-bedroom apartments invite you to experience modern living with a community touch. Step inside from the comfort of home with our virtual tour, showcasing stunning spaces and amenities that await you! Don’t miss your chance to envision your new lifestyle!",
  "property_copyright": "2026 All Rights Reserved. The Pavilion",
  "property_seo_title_home": "The Pavilion |  Apartments in Hanceville, AL",
  "property_seo_description_home": "Discover life at The Pavilion in Hanceville, AL! Enjoy spacious floor plans, modern amenities, and a vibrant community near campus!",
  "property_seo_title_floorplans": "Floor Plans | Hanceville, AL Apartments for Rent",
  "property_seo_description_floorplans": "Discover your perfect home at The Pavilion in Hanceville, AL! Explore cozy one-bedrooms to spacious three-bedrooms in our floor plans.",
  "property_seo_title_amenities": "Amenities | Hanceville, AL Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at The Pavilion in Hanceville, AL! Spacious floor plans, pet park, grilling areas, and maintenance-free living near campus.",
  "property_seo_title_gallery": "Gallery | Apartments in Hanceville, AL",
  "property_seo_description_gallery": "Discover your dream life at The Pavilion, Hanceville, AL! Stylish apartments with great amenities, just steps from campus. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | The Pavilion Apartments",
  "property_seo_description_virtualtours": "Step inside The Pavilion in Hanceville, AL! Take a virtual tour of our inviting one to three-bedroom apartments and discover your ideal living space today!",
  "property_seo_title_interactivemap": "Interactive Map | The Pavilion Apartments",
  "property_seo_description_interactivemap": "Discover The Pavilion in Hanceville, AL—spacious apartments, modern amenities, and a vibrant community just steps from campus. Your new home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hanceville, AL",
  "property_seo_description_neighborhood": "Uncover local gems around The Pavilion in Hanceville, AL. From parks to dining, see what makes our neighborhood the perfect place to call home!",
  "property_seo_title_contact": "Contact Us | The Pavilion",
  "property_seo_description_contact": "Connect with The Pavilion in Hanceville, AL! Choose from one to three-bedroom floor plans. Have questions? Our friendly leasing team is here to help you!",
  "property_seo_title_faqs": "FAQs | Apartments in Hanceville, AL",
  "property_seo_description_faqs": "Find answers to your questions about The Pavilion in Hanceville, AL. From floor plans to pet parks, we’ve got the details you need for your perfect home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hanceville, AL",
  "property_seo_description_reviews": "Discover life at The Pavilion in Hanceville, AL! Read resident reviews on our spacious homes, great amenities, and vibrant campus community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Hanceville, AL",
  "property_seo_description_applynow": "Experience life at The Pavilion in Hanceville, AL. Enjoy spacious floor plans, pet-friendly amenities, and a prime campus location—your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Pavilion",
  "property_seo_description_residentaccess": "Elevate your living at The Pavilion in Hanceville! Log in to your resident portal for rent payments, maintenance requests, and a seamless community experience.",
  "property_seo_title_referafriend": "Refer A Friend | The Pavilion",
  "property_seo_description_referafriend": "Refer a friend to The Pavilion in Hanceville, AL! Great friends make the best neighbors—share the joy of community living with someone special today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Pavilion",
  "property_seo_description_scheduletour": "Experience life at The Pavilion in Hanceville, AL. Schedule a tour today and envision your new home in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Pavilion",
  "property_seo_description_privacy": "Your privacy matters at The Pavilion. Learn how we protect your information and ensure a secure living experience in Hanceville, AL. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Pavilion",
  "property_seo_description_accessibility": "At The Pavilion in Hanceville, AL, we promote digital inclusivity, ensuring everyone can connect and thrive in our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | The Pavilion",
  "property_seo_description_sitemap": "Navigate The Pavilion’s offerings in Hanceville, AL, with ease. Check out our sitemap for a seamless journey through your future home and community features.",
  "property_seo_title_thankyou": "Thank You | The Pavilion",
  "property_seo_description_thankyou": "Thank you for reaching out to The Pavilion in Hanceville, AL! Expect a warm response from our team soon—your future home awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Hanceville, AL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793478401",
  "amenities": [
    {
      "id": "custom_489d354f-7da3-4c1b-bd2d-184b1aa87ded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Located One Block From Campus",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6ea90a9-8eed-4106-9120-6ed22044f27a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abbde862-7683-4cf7-bf59-57e6c4985c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_697793e9-6435-4001-80be-92053ed57c6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1aaffa42-c813-4a9f-b986-5b7e6af0e8fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2392c013-a6ef-413f-ae39-9b017ce09f98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Surface Lot Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed79e51e-b1fb-4e9a-874c-01a259fac651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7184d2ba-3a2b-4770-8d45-2fb947543f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ae4b905-333a-435a-ad51-ce542b329aed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance‑Free Lifestyle",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_655144b2-64a1-4aac-b9ad-4d06146ba9e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb8f4b50-fded-4c59-a8a0-9604ca992a38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_575683a2-c0e1-44ce-a14c-06c606e7256e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f3bb318-0b16-4c61-bd97-a829ec9dbc1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Hard Surface Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35afa6a6-acf6-421f-aab4-735cb4eaa928",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "*All‑Black Appliances",
      "amount": "false",
      "description": "Only in select apartment homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d84f16e5-b331-4d7a-9e06-c5a4acaacf50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce7a59b5-4fd7-468c-b3ff-b148df86e0dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff201111-2815-4dcb-8e88-8d2d72bda948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "Ample Closet Space",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23fc3814-2a01-4093-942f-791bededcfd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "*Washer and Dryer Connections",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e118bce1-d56d-4933-bd44-d348f2a6d7c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "external_id": "false",
      "title": "*Double Closets",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_dcadfbd8-4a4c-4c0b-b711-e3988421730d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ef-3416-73f8-ae7e-45cfe8d9dc44.webp",
      "image_media": {
        "alt_text": "The Pavilion at College Drive monument sign in Hanceville, AL",
        "public_id": "019e02ef-3416-73f8-ae7e-45cfe8d9dc44",
        "storage_key": "property/6767906449167338/019e02ef-3416-73f8-ae7e-45cfe8d9dc44.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Pavilion at College Drive, a beautiful community offering comfortable living.",
      "link": "",
      "alt_text": "The Pavilion at College Drive monument sign in Hanceville, AL",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3dad7ab4-1c70-4335-9ab1-e5cf3cb6e698",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-da9c-765c-b7fb-ec74af793f82.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with a pergola, tables, and chairs at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019e02ed-da9c-765c-b7fb-ec74af793f82",
        "storage_key": "property/6767906449167338/019e02ed-da9c-765c-b7fb-ec74af793f82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community grilling station, complete with a spacious pergola, comfortable seating, and a built-in grill for all your entertaining needs.",
      "link": "",
      "alt_text": "Outdoor grilling area with a pergola, tables, and chairs at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a441cad7-f592-4240-8fc8-c180abaa7d78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-d683-739a-850f-ed6c097f01aa.webp",
      "image_media": {
        "alt_text": "Laundry room with washers, dryers, vending machines, and seating area at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019e02ed-d683-739a-850f-ed6c097f01aa",
        "storage_key": "property/6767906449167338/019e02ed-d683-739a-850f-ed6c097f01aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities featuring multiple washers and dryers, vending machines for snacks and drinks, and a comfortable seating area for residents.",
      "link": "",
      "alt_text": "Laundry room with washers, dryers, vending machines, and seating area at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9222dec-d10a-4861-977d-24a8fe58b85c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-d6dd-708a-a01b-ec73b64a01c6.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with light gray siding and dark doors at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019e02ed-d6dd-708a-a01b-ec73b64a01c6",
        "storage_key": "property/6767906449167338/019e02ed-d6dd-708a-a01b-ec73b64a01c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This exterior image showcases the apartment building's architecture, featuring light gray siding, windows, and multiple unit entrances with balconies on the upper level.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with light gray siding and dark doors at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c9d7963-9cbf-4718-afcb-c866d1e88d9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-d5f3-77de-9a73-4d554791def6.webp",
      "image_media": {
        "alt_text": "The Pavilion Apartment Homes monument sign in Hanceville, AL",
        "public_id": "019e02ed-d5f3-77de-9a73-4d554791def6",
        "storage_key": "property/6767906449167338/019e02ed-d5f3-77de-9a73-4d554791def6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Pavilion Apartment Homes. Discover your new home with us.",
      "link": "",
      "alt_text": "The Pavilion Apartment Homes monument sign in Hanceville, AL",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df10310a-e159-481e-8eb4-22de86632530",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-db16-716b-90a6-9ad8fd315b8b.webp",
      "image_media": {
        "alt_text": "A seating area with four chairs, two nesting coffee tables, and a decorative rug at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019e02ed-db16-716b-90a6-9ad8fd315b8b",
        "storage_key": "property/6767906449167338/019e02ed-db16-716b-90a6-9ad8fd315b8b.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Relax and unwind in this cozy seating area, perfect for gathering with friends or enjoying a quiet moment.",
      "link": "",
      "alt_text": "A seating area with four chairs, two nesting coffee tables, and a decorative rug at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57507355-b006-4463-8ff3-e510056001d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019e02ed-d7e8-719c-b773-250960677df0.webp",
      "image_media": {
        "alt_text": "Bathroom with yellow and grey chevron shower curtain, towels, and decorative items at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019e02ed-d7e8-719c-b773-250960677df0",
        "storage_key": "property/6767906449167338/019e02ed-d7e8-719c-b773-250960677df0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-appointed bathroom featuring a stylish yellow and grey chevron shower curtain, plush towels, and decorative wall art.",
      "link": "",
      "alt_text": "Bathroom with yellow and grey chevron shower curtain, towels, and decorative items at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75309d79-20b1-4447-bd68-fbede65a387e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1b84-71fe-a0df-b6c7c98a31b9.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with green landscaping and parking lot at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-1b84-71fe-a0df-b6c7c98a31b9",
        "storage_key": "property/6767906449167338/019d7970-1b84-71fe-a0df-b6c7c98a31b9.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Charming brick apartment buildings with lush green landscaping and convenient parking, offering a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with green landscaping and parking lot at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ca9f177-508c-48e1-8d3b-53f02b9db147",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-0eb0-7733-93c5-9bb74f383089.webp",
      "image_media": {
        "alt_text": "Wooden gazebo with picnic tables and benches in a courtyard setting at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-0eb0-7733-93c5-9bb74f383089",
        "storage_key": "property/6767906449167338/019d7970-0eb0-7733-93c5-9bb74f383089.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our charming wooden gazebo, perfect for picnics or relaxing with friends.",
      "link": "",
      "alt_text": "Wooden gazebo with picnic tables and benches in a courtyard setting at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2fb917c-2f44-4d5f-9816-576d0fa21699",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-0ef4-7135-8eab-b968c2958795.webp",
      "image_media": {
        "alt_text": "Office desk with computer, printer, and abstract art at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-0ef4-7135-8eab-b968c2958795",
        "storage_key": "property/6767906449167338/019d7970-0ef4-7135-8eab-b968c2958795.webp",
        "width": 1440,
        "height": 1920
      },
      "title": "Other",
      "description": "A modern office desk setup featuring a computer, printer, and decorative abstract art, providing a professional and organized workspace.",
      "link": "",
      "alt_text": "Office desk with computer, printer, and abstract art at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c21f9034-7263-435e-bd39-7a7a6f9effbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1190-7011-b7cc-ce9a0353405f.webp",
      "image_media": {
        "alt_text": "Picnic tables and grills in a grassy courtyard area with brick buildings in the background at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-1190-7011-b7cc-ce9a0353405f",
        "storage_key": "property/6767906449167338/019d7970-1190-7011-b7cc-ce9a0353405f.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling with community picnic tables and barbecue grills available for residents.",
      "link": "",
      "alt_text": "Picnic tables and grills in a grassy courtyard area with brick buildings in the background at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd9510f7-6fe6-40a1-bd78-a04037131d5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-15f4-71cc-b1c4-1f56fadf3b32.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, black appliances, and granite countertops at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-15f4-71cc-b1c4-1f56fadf3b32",
        "storage_key": "property/6767906449167338/019d7970-15f4-71cc-b1c4-1f56fadf3b32.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Apartment",
      "description": "Renovated kitchen featuring sleek gray cabinetry, a black electric range, dishwasher, double sink, and durable granite countertops. Wood-look vinyl flooring completes the contemporary look.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, black appliances, and granite countertops at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ebd26de3-0ec0-4ede-95e8-323ba5c53a95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-10cd-7657-a425-1607847dcff7.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with white stairs and balconies at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-10cd-7657-a425-1607847dcff7",
        "storage_key": "property/6767906449167338/019d7970-10cd-7657-a425-1607847dcff7.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing the building entrances, stairs, and balconies, set against a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with white stairs and balconies at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9087d780-ed44-4e04-91f2-741a1f35026c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1105-775a-8eba-735da0ff3a61.webp",
      "image_media": {
        "alt_text": "Wooden gazebo with picnic tables and a brick building with a black door at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-1105-775a-8eba-735da0ff3a61",
        "storage_key": "property/6767906449167338/019d7970-1105-775a-8eba-735da0ff3a61.webp",
        "width": 1500,
        "height": 1159
      },
      "title": "Community",
      "description": "Enjoy the outdoors in the charming wooden gazebo, perfect for gatherings, or relax near the welcoming community building.",
      "link": "",
      "alt_text": "Wooden gazebo with picnic tables and a brick building with a black door at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5847ea9c-b95b-4587-a928-a35e752d0be6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1103-77f1-aa9d-78abccc648db.webp",
      "image_media": {
        "alt_text": "Wooden gazebo with hanging flower baskets next to a brick building with white siding at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-1103-77f1-aa9d-78abccc648db",
        "storage_key": "property/6767906449167338/019d7970-1103-77f1-aa9d-78abccc648db.webp",
        "width": 1102,
        "height": 702
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this charming gazebo, perfect for relaxing or socializing amidst beautiful landscaping.",
      "link": "",
      "alt_text": "Wooden gazebo with hanging flower baskets next to a brick building with white siding at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54f6aaea-b916-4d93-9f50-fdaca185386f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d7970-1105-775a-8eba-6d4c66d4e9ce.webp",
      "image_media": {
        "alt_text": "Living room with a gray couch, coffee table, and water cooler at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d7970-1105-775a-8eba-6d4c66d4e9ce",
        "storage_key": "property/6767906449167338/019d7970-1105-775a-8eba-6d4c66d4e9ce.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Apartment",
      "description": "A comfortable living area featuring a plush gray sofa with red accent pillows, a modern concrete-look coffee table, and a convenient water dispenser. Decorated with abstract art and a wall clock.",
      "link": "",
      "alt_text": "Living room with a gray couch, coffee table, and water cooler at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5888195-2f61-4d17-8608-64cd0abf726a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d796f-fdf5-73af-b1c6-81cad0e50399.webp",
      "image_media": {
        "alt_text": "Wooden gazebo with picnic tables in a community courtyard at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d796f-fdf5-73af-b1c6-81cad0e50399",
        "storage_key": "property/6767906449167338/019d796f-fdf5-73af-b1c6-81cad0e50399.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in the charming wooden gazebo, complete with picnic tables, perfect for community events or a relaxing afternoon.",
      "link": "",
      "alt_text": "Wooden gazebo with picnic tables in a community courtyard at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f074f52-c138-4cd6-83f6-82f47b86eb73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d796f-f7a9-71ab-b956-0ab2007b398b.webp",
      "image_media": {
        "alt_text": "Interior of an apartment kitchen and living room at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d796f-f7a9-71ab-b956-0ab2007b398b",
        "storage_key": "property/6767906449167338/019d796f-f7a9-71ab-b956-0ab2007b398b.webp",
        "width": 1440,
        "height": 1920
      },
      "title": "Apartment",
      "description": "An empty apartment unit featuring a modern kitchen with stainless steel appliances and a spacious living area with hardwood floors.",
      "link": "",
      "alt_text": "Interior of an apartment kitchen and living room at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9db420c2-1246-429d-b53e-012df2f00145",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d796f-f7ba-75af-8aa0-03594a8e6087.webp",
      "image_media": {
        "alt_text": "Mailboxes and laundry room with washers and dryers at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d796f-f7ba-75af-8aa0-03594a8e6087",
        "storage_key": "property/6767906449167338/019d796f-f7ba-75af-8aa0-03594a8e6087.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Community",
      "description": "Convenient mailboxes and a fully equipped laundry room with multiple washers and dryers for residents.",
      "link": "",
      "alt_text": "Mailboxes and laundry room with washers and dryers at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_87b30a4d-5a9d-4146-a65a-df7b536e0498",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d796f-f6e5-71c8-ba93-27b5f8db0719.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with balconies and external staircases at The Pavilion Apartments in Hanceville, AL.",
        "public_id": "019d796f-f6e5-71c8-ba93-27b5f8db0719",
        "storage_key": "property/6767906449167338/019d796f-f6e5-71c8-ba93-27b5f8db0719.webp",
        "width": 1500,
        "height": 955
      },
      "title": "Community",
      "description": "Exterior view showcasing the brick facade, balconies, and external staircases of the apartment building under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with balconies and external staircases at The Pavilion Apartments in Hanceville, AL.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_670290e4-1708-4c39-914e-4261a413ce1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Ledger's Steakhouse and Grille",
      "poi_type": "Restaurants",
      "poi_address": "281 Co Rd 717, Cullman, AL 35055, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this steakhouse serves up delicious Delmonico ribeye, stuffed chicken, and a well-stocked salad bar. They also highlight the friendly and attentive staff, and the warm and inviting atmosphere.\n\nSome reviews mention the steaks can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-69f0-708e-bff0-f3ce58d94456.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered patio overlooking a pond and green landscape.",
        "public_id": "019d54fd-69f0-708e-bff0-f3ce58d94456",
        "storage_key": "property/6767906449167338/019d54fd-69f0-708e-bff0-f3ce58d94456.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.stonebridgewedding.com/ledgers",
      "poi_directions_map_url": "https://maps.google.com/?cid=11468767456777187599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ledgers-steakhouse-and-grille",
      "poi_latitude": "34.140694",
      "poi_longitude": "-86.7899583",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 256-734-9765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54fd-d56a-74b3-9d15-f559ba91b2e9",
        "storage_key": "property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4GtgKXJiYgRD7HD4Dw_KZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2f83a173-3d32-4d09-96c0-ee802410d9a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Bubba Ritos",
      "poi_type": "Restaurants",
      "poi_address": "520 AL-69, Hanceville, AL 35077, USA",
      "poi_short_description": "Casual eatery featuring tacos, burritos and bowls, plus a salsa bar.",
      "poi_long_description": "People say this restaurant serves delicious rice bowls, burritos, and tacos with fresh ingredients and generous portions. They highlight the customizable menu, allowing diners to choose their own ingredients, and the good value for the price. They also like the friendly and efficient service, and the clean and cozy atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-590a-730c-9c95-6121de261a5e.webp",
      "poi_featured_image_media": {
        "alt_text": "Restaurant dining area with tables and chairs.",
        "public_id": "019d54fd-590a-730c-9c95-6121de261a5e",
        "storage_key": "property/6767906449167338/019d54fd-590a-730c-9c95-6121de261a5e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://bubbaritos.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5313946024249051350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bubba-ritos",
      "poi_latitude": "34.0496478",
      "poi_longitude": "-86.87309619999999",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 256-887-1033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54fd-d56a-74b3-9d15-f559ba91b2e9",
        "storage_key": "property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgb_UlY61iYgR1sj2KsHtvkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fc8debf6-f435-4b37-a2e4-ea546a554443",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Jack's Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "325 AL-69, Hanceville, AL 35077, USA",
      "poi_short_description": "Fast-food chain serving standard American eats such as burgers, fries & milkshakes.",
      "poi_long_description": "People say this fast food restaurant serves delicious breakfast, including tasty eggs, sausage, biscuits, and sausage gravy, with great value for the price. They also highlight the friendly and helpful staff, and the clean dining area.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-6346-772f-b747-6506b59f9c47.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Jack's restaurant with prominent signage and drive-thru.",
        "public_id": "019d54fd-6346-772f-b747-6506b59f9c47",
        "storage_key": "property/6767906449167338/019d54fd-6346-772f-b747-6506b59f9c47.webp",
        "width": 3072,
        "height": 2040
      },
      "poi_business_url": "https://locations.eatatjacks.com/al/hanceville/325-alabama-hwy-69-south/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3002176122547178750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacks-family-restaurant",
      "poi_latitude": "34.0508797",
      "poi_longitude": "-86.8700308",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-287-9933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54fd-d56a-74b3-9d15-f559ba91b2e9",
        "storage_key": "property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbpjOfK0iYgR_oyV-UbfqSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d1e62a4c-72d7-4319-94f3-1abacefcfc83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "1707 Co Rd 437, Good Hope, AL 35055, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "People say this breakfast restaurant serves excellent food. They also highlight the great service and friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-57b3-71b8-b279-43d9047a72b6.webp",
      "poi_featured_image_media": {
        "alt_text": "Kitchen staff preparing food behind a counter.",
        "public_id": "019d54fd-57b3-71b8-b279-43d9047a72b6",
        "storage_key": "property/6767906449167338/019d54fd-57b3-71b8-b279-43d9047a72b6.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://locations.wafflehouse.com/goodhope-al-456",
      "poi_directions_map_url": "https://maps.google.com/?cid=4745742653992934687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "34.1148573",
      "poi_longitude": "-86.8638746",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-734-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54fd-d56a-74b3-9d15-f559ba91b2e9",
        "storage_key": "property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09dxR4DKiYgRHx2rvsxD3EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_3e0e1b5f-bf7d-4fd7-b7aa-c1a6263a14bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Pop's Place Bar B Q",
      "poi_type": "Restaurants",
      "poi_address": "721 AL-69, Hanceville, AL 35077, USA",
      "poi_short_description": "Relaxed, no-frills joint serving a menu of smoked meats, including brisket, turkey and ribs, with homemade potato chips, baked beans and slaw.",
      "poi_long_description": "People say this barbecue restaurant serves a delicious breakfast. They highlight the reasonable prices and tasty food. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-549a-7676-8068-a57e654bc88a.webp",
      "poi_featured_image_media": {
        "alt_text": "Pop's Place Bar B Q building exterior with signage.",
        "public_id": "019d54fd-549a-7676-8068-a57e654bc88a",
        "storage_key": "property/6767906449167338/019d54fd-549a-7676-8068-a57e654bc88a.webp",
        "width": 1440,
        "height": 895
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15501519903956783072&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pops-place-bar-b-q",
      "poi_latitude": "34.0468422",
      "poi_longitude": "-86.87480269999999",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-887-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
      "poi_map_icon_media": {
        "alt_text": "Fork and knife icon",
        "public_id": "019d54fd-d56a-74b3-9d15-f559ba91b2e9",
        "storage_key": "property/6767906449167338/019d54fd-d56a-74b3-9d15-f559ba91b2e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTy2ydIpKiIgR4M_92Th2INc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8324809c-f814-4668-96e9-3f2afcbf19d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Jack's Western & Outdoor Wear",
      "poi_type": "Shopping & Retail",
      "poi_address": "114 Schwaiger Rd, Cullman, AL 35055, USA",
      "poi_short_description": "Chain retailer carrying the brand's signature jewelry, accessories, leather handbags & more.",
      "poi_long_description": "People say this clothing store offers a wide variety of boots, hats, belts, and western clothing, including adorable western shirts for infants. They highlight the friendly and helpful staff, and the welcoming and family-like atmosphere. They also like the great selection of work clothes and hunting gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-590b-706e-bd66-862a78ca358e.webp",
      "poi_featured_image_media": {
        "alt_text": "Jack's Western & Outdoor store exterior with parked cars",
        "public_id": "019d54fd-590b-706e-bd66-862a78ca358e",
        "storage_key": "property/6767906449167338/019d54fd-590b-706e-bd66-862a78ca358e.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://jackswestern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16283944264882076073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacks-western--outdoor-wear",
      "poi_latitude": "34.1130458",
      "poi_longitude": "-86.8647625",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 256-739-3612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54fd-d569-76bd-839a-a978827ee893",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe0PqOX61iYgRqTmOaggx_OE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_f76e2bc8-4701-4aeb-b10c-287ae00f55b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Warehouse Discount Groceries of Hanceville",
      "poi_type": "Shopping & Retail",
      "poi_address": "780 Main St NE, Hanceville, AL 35077, USA",
      "poi_short_description": "Grocery store offering discounted prices on produce, meat, and other staples, plus a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-5584-704d-b5ab-dead89db50c2.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a WDG Warehouse Discount Groceries store with large red letters WDG and a yellow sign.",
        "public_id": "019d54fd-5584-704d-b5ab-dead89db50c2",
        "storage_key": "property/6767906449167338/019d54fd-5584-704d-b5ab-dead89db50c2.webp",
        "width": 1800,
        "height": 2463
      },
      "poi_business_url": "https://www.warehousediscountgroceries.com/store-locations/warehouse-discount-groceries-of-hanceville/?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=1608181067094430559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "warehouse-discount-groceries-of-hanceville",
      "poi_latitude": "34.0725",
      "poi_longitude": "-86.77666669999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 256-352-6245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a4d75f2aa212.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54fd-d569-76bd-839a-a4d75f2aa212",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a4d75f2aa212.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcXDk4qu3iYgRXxOs9ihoURY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_96d1e2c1-9206-4d41-8dc7-a174dcf57ca2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "DG Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "872 Main St NE, Hanceville, AL 35077, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-553d-7116-abea-6bbc0e8d64f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Dollar General Market store building with a large green 'market' sign.",
        "public_id": "019d54fd-553d-7116-abea-6bbc0e8d64f4",
        "storage_key": "property/6767906449167338/019d54fd-553d-7116-abea-6bbc0e8d64f4.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/al/hanceville/13195",
      "poi_directions_map_url": "https://maps.google.com/?cid=17603842973311037592&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dg-market",
      "poi_latitude": "34.0773468",
      "poi_longitude": "-86.7812728",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-787-2468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a4d75f2aa212.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54fd-d569-76bd-839a-a4d75f2aa212",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a4d75f2aa212.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxq2tlK2iYgRmPD1QeppTfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e243ba1d-3f41-41ec-9deb-2299a346668f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "All Star Appliance",
      "poi_type": "Shopping & Retail",
      "poi_address": "15 Co Rd 486, Hanceville, AL 35077, USA",
      "poi_short_description": "Appliance shop offering new and used washers, dryers, and kids' electric bikes, plus installations and repairs.",
      "poi_long_description": "People say this used appliance store offers washers and dryers. They highlight the prices are cheaper than most places in the surrounding areas. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-58ab-7350-97d2-7f337a83f37c.webp",
      "poi_featured_image_media": {
        "alt_text": "All Star Appliance Service logo and contact information",
        "public_id": "019d54fd-58ab-7350-97d2-7f337a83f37c",
        "storage_key": "property/6767906449167338/019d54fd-58ab-7350-97d2-7f337a83f37c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037480706274880740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "all-star-appliance",
      "poi_latitude": "34.1258478",
      "poi_longitude": "-86.8163648",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 256-203-6811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54fd-d569-76bd-839a-a978827ee893",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ69Jnt5DJiYgR5OyxbbuTkN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_3bdfd251-36f5-46ec-a572-526c319998bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Sew Blessed Fabric & Embroidery",
      "poi_type": "Shopping & Retail",
      "poi_address": "445 AL-69 Suite C, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-5583-77d9-8853-09a542a2a3b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage and entrance of a fabric and embroidery store.",
        "public_id": "019d54fd-5583-77d9-8853-09a542a2a3b2",
        "storage_key": "property/6767906449167338/019d54fd-5583-77d9-8853-09a542a2a3b2.webp",
        "width": 1080,
        "height": 919
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9255612143055428976&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sew-blessed-fabric--embroidery",
      "poi_latitude": "34.0496678",
      "poi_longitude": "-86.87131339999999",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 205-790-7339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54fd-d569-76bd-839a-a978827ee893",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a978827ee893.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQdceF2i1iYgRcF2crTSKcoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_805bda3e-eb86-41cf-b51b-6990721ebe3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Wallace State Community College",
      "poi_type": "Education",
      "poi_address": "801 Main St NW, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-7d61-745f-88b8-aa8ae0f6fb34.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings and parking lots at sunset.",
        "public_id": "019d54fd-7d61-745f-88b8-aa8ae0f6fb34",
        "storage_key": "property/6767906449167338/019d54fd-7d61-745f-88b8-aa8ae0f6fb34.webp",
        "width": 3072,
        "height": 2414
      },
      "poi_business_url": "https://www.wallacestate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5472661861852448381&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wallace-state-community-college",
      "poi_latitude": "34.07096420000001",
      "poi_longitude": "-86.78198119999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-352-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d573-70c5-b3f1-74a58f9132da.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54fd-d573-70c5-b3f1-74a58f9132da",
        "storage_key": "property/6767906449167338/019d54fd-d573-70c5-b3f1-74a58f9132da.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJV3td1S2iYgRfQaLy_fM8ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bc3abbc4-71f0-4560-9ea1-a9cba4a7c6ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Wallace State Community College Library",
      "poi_type": "Education",
      "poi_address": "91 Lions Ln, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wallacestate.edu/library/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5541442279755156098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wallace-state-community-college-library",
      "poi_latitude": "34.0730285",
      "poi_longitude": "-86.78349779999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54fd-d58c-7614-856a-d236c54fba1c",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG13vZVO2iYgRggojxGQo50w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_287630f5-04c0-4fc2-8366-1473f6e678f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Hanceville Public Library",
      "poi_type": "Education",
      "poi_address": "201 Commercial St, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-7159-7207-92c4-6822e079315f.webp",
      "poi_featured_image_media": {
        "alt_text": "Shirley Burden Public Library exterior signage and building facade in Hanceville, AL.",
        "public_id": "019d54fd-7159-7207-92c4-6822e079315f",
        "storage_key": "property/6767906449167338/019d54fd-7159-7207-92c4-6822e079315f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ccpls.com/hanceville.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14411402703311307424&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hanceville-public-library",
      "poi_latitude": "34.0597157",
      "poi_longitude": "-86.7671881",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-352-0685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d573-70c5-b3f1-74a58f9132da.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54fd-d573-70c5-b3f1-74a58f9132da",
        "storage_key": "property/6767906449167338/019d54fd-d573-70c5-b3f1-74a58f9132da.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC4oqaam3iYgRoIL5XWeW_8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_543ee55f-30a5-4609-867c-36cf261e5408",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Hanceville High School Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Stadium St, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-70e7-71f2-b553-3c3217f6c505.webp",
      "poi_featured_image_media": {
        "alt_text": "High school football game at night with a marching band on the field and spectators in the stands.",
        "public_id": "019d54fd-70e7-71f2-b553-3c3217f6c505",
        "storage_key": "property/6767906449167338/019d54fd-70e7-71f2-b553-3c3217f6c505.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1459229642957030193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hanceville-high-school-stadium",
      "poi_latitude": "34.0588992",
      "poi_longitude": "-86.7623421",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 256-352-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58f-7618-af06-c05dcf77f3ac.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of two figures sitting at a table",
        "public_id": "019d54fd-d58f-7618-af06-c05dcf77f3ac",
        "storage_key": "property/6767906449167338/019d54fd-d58f-7618-af06-c05dcf77f3ac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-_aOI2G3iYgRMYMsAqE5QBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e860c7c2-df4c-46b2-8611-626238f7de78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Traditions Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "240 Championship Blvd, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-6fb3-761d-997f-a448f9ea4971.webp",
      "poi_featured_image_media": {
        "alt_text": "Basketball court with seating in background",
        "public_id": "019d54fd-6fb3-761d-997f-a448f9ea4971",
        "storage_key": "property/6767906449167338/019d54fd-6fb3-761d-997f-a448f9ea4971.webp",
        "width": 799,
        "height": 533
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476289905274785462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "traditions-bank-arena",
      "poi_latitude": "34.0721627",
      "poi_longitude": "-86.7886788",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbgy-i63iYgRtg6yDpGvJK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_19acafec-d1da-4df5-ba58-5087af2c1e6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "The Evelyn Burrow Museum",
      "poi_type": "Entertainment",
      "poi_address": "108 College Dr NW, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-6bff-77d8-9f6f-7e34b80b147b.webp",
      "poi_featured_image_media": {
        "alt_text": "Art gallery interior with sculptures and paintings displayed on wooden floors.",
        "public_id": "019d54fd-6bff-77d8-9f6f-7e34b80b147b",
        "storage_key": "property/6767906449167338/019d54fd-6bff-77d8-9f6f-7e34b80b147b.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "http://www.burrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14043863474187460333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-evelyn-burrow-museum",
      "poi_latitude": "34.0708394",
      "poi_longitude": "-86.7778452",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 256-352-8457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58d-7315-a6e9-fda36e1fe61a.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M",
        "public_id": "019d54fd-d58d-7315-a6e9-fda36e1fe61a",
        "storage_key": "property/6767906449167338/019d54fd-d58d-7315-a6e9-fda36e1fe61a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJkafj3au3iYgR7d4GFWzT5cI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_eab94bd3-d205-4202-a000-30151bb5c820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "John Paul II Eucharistic Center",
      "poi_type": "Entertainment",
      "poi_address": "Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-75f9-73c8-80f7-f64adde4e86d.webp",
      "poi_featured_image_media": {
        "alt_text": "Two knights in armor flanking a statue of Joan of Arc, decorated for Christmas.",
        "public_id": "019d54fd-75f9-73c8-80f7-f64adde4e86d",
        "storage_key": "property/6767906449167338/019d54fd-75f9-73c8-80f7-f64adde4e86d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16800047626110903545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-paul-ii-eucharistic-center",
      "poi_latitude": "34.0567064",
      "poi_longitude": "-86.6912964",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-352-6267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58d-7315-a6e9-fda36e1fe61a.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M",
        "public_id": "019d54fd-d58d-7315-a6e9-fda36e1fe61a",
        "storage_key": "property/6767906449167338/019d54fd-d58d-7315-a6e9-fda36e1fe61a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4DO-9C5iYgR-ST8M07CJek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_518bbfe1-ae0b-49c5-ab3e-b5286ccd4461",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "388 Championship Blvd, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-761f-723c-b3ee-035564996e36.webp",
      "poi_featured_image_media": {
        "alt_text": "People playing flag football on a grassy field with bleachers and a tower in the background.",
        "public_id": "019d54fd-761f-723c-b3ee-035564996e36",
        "storage_key": "property/6767906449167338/019d54fd-761f-723c-b3ee-035564996e36.webp",
        "width": 3072,
        "height": 1729
      },
      "poi_business_url": "https://busiussa.org/details/wellness-center-ChIJ740",
      "poi_directions_map_url": "https://maps.google.com/?cid=8334896008661874654&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wellness-center",
      "poi_latitude": "34.0730623",
      "poi_longitude": "-86.7886434",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ740TCVS2iYgR3rccfMJ_q3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ba184fe9-72c3-46f7-b312-66c549e6ecf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Pro Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "924 Main St NE, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-7fd9-739e-8eb8-4bb573c926eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Close-up of a hand with black and clear stiletto nails adorned with heart-shaped glitter and small rhinestones.",
        "public_id": "019d54fd-7fd9-739e-8eb8-4bb573c926eb",
        "storage_key": "property/6767906449167338/019d54fd-7fd9-739e-8eb8-4bb573c926eb.webp",
        "width": 3024,
        "height": 3024
      },
      "poi_business_url": "http://gopronails.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13860987053180291709&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pro-nails",
      "poi_latitude": "34.0803401",
      "poi_longitude": "-86.7855933",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-352-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQMxY022iYgRfYoZRUkeXMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_c3cb6e21-71c2-4400-8378-5bb953ae52a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Animal Medical Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10161 US-31, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-94d6-772b-8f8b-c20dda2a8a22.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a veterinary clinic with a closed door, American flag, and a fireplace.",
        "public_id": "019d54fd-94d6-772b-8f8b-c20dda2a8a22",
        "storage_key": "property/6767906449167338/019d54fd-94d6-772b-8f8b-c20dda2a8a22.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.animal-medical-hospital.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6106573594332268666&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-medical-hospital",
      "poi_latitude": "34.1244982",
      "poi_longitude": "-86.8150194",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 256-739-9318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTQL_fDJiYgReoj0fFTovlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_72ea2095-2ac4-44f7-b4f1-ffff9dcd84bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Cut N Up Barber And Style",
      "poi_type": "Health and Wellness",
      "poi_address": "105 Commercial St SE, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-902c-70f0-bff7-bff72cfcef48.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman with blonde hair with blue streaks, wearing a yellow patterned smock, sitting in a salon chair.",
        "public_id": "019d54fd-902c-70f0-bff7-bff72cfcef48",
        "storage_key": "property/6767906449167338/019d54fd-902c-70f0-bff7-bff72cfcef48.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5341331857740596508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cut-n-up-barber-and-style",
      "poi_latitude": "34.0590873",
      "poi_longitude": "-86.76793909999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-636-2018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3U7P6g63iYgRHAUbaAY5IEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_4873fda7-13a3-419c-b227-905d1fdf14d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Glamorous Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "110 Main St SE, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-8fcb-751b-a891-38cc37fcf4dc.webp",
      "poi_featured_image_media": {
        "alt_text": "Grand Opening invitation for Glamorous Nails & Spa with golden curtains and scissors.",
        "public_id": "019d54fd-8fcb-751b-a891-38cc37fcf4dc",
        "storage_key": "property/6767906449167338/019d54fd-8fcb-751b-a891-38cc37fcf4dc.webp",
        "width": 1175,
        "height": 1571
      },
      "poi_business_url": "https://www.glamorousnailsnspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544594054210569667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glamorous-nails--spa",
      "poi_latitude": "34.0588375",
      "poi_longitude": "-86.7675806",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 256-595-8501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8GRjS-3iYgRw8WSyTakET8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_e329193f-ce4c-49e8-9bb6-4abf0d35dcdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Johnny's Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "25 Co Rd 262, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-9aa7-70d8-bde2-73dcff6bd918.webp",
      "poi_featured_image_media": {
        "alt_text": "Barber shop exterior with barber pole and open sign",
        "public_id": "019d54fd-9aa7-70d8-bde2-73dcff6bd918",
        "storage_key": "property/6767906449167338/019d54fd-9aa7-70d8-bde2-73dcff6bd918.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18427940480005768709&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnnys-barbershop",
      "poi_latitude": "34.0488487",
      "poi_longitude": "-86.8741542",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-287-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7xuevK0iYgRBQbJLDsyvf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_04580884-86dc-4add-9a55-5346a99ea90e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Morring Roy S DVM",
      "poi_type": "Health and Wellness",
      "poi_address": "10161 US-31, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-9c3d-7771-b601-8a5fa52667f5.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior signage and decor in a veterinary clinic office.",
        "public_id": "019d54fd-9c3d-7771-b601-8a5fa52667f5",
        "storage_key": "property/6767906449167338/019d54fd-9c3d-7771-b601-8a5fa52667f5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13046097897053095895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "morring-roy-s-dvm",
      "poi_latitude": "34.1244982",
      "poi_longitude": "-86.8150194",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 256-739-9318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWqrgOHJiYgR1wfSiuoMDbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_41f6f7ba-11db-4301-9005-a39f0754a3c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Serenity Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "107 Bangor Ave # E, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-a78b-719c-be92-799733e1265e.webp",
      "poi_featured_image_media": {
        "alt_text": "Serenity Salon sign with phone number 256-347-3776.",
        "public_id": "019d54fd-a78b-719c-be92-799733e1265e",
        "storage_key": "property/6767906449167338/019d54fd-a78b-719c-be92-799733e1265e.webp",
        "width": 2726,
        "height": 1448
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6098029725290757076&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "serenity-salon",
      "poi_latitude": "34.0598219",
      "poi_longitude": "-86.7680603",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-347-3776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpYVBwuu3iYgR1Hu69bmNoFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_c5797136-4b23-44f6-80d8-defc45296ea9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Color Me Crazy Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "107 Bangor Ave, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-9ad3-7148-bd1b-f400ae1a89ef.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a building during a rainstorm.",
        "public_id": "019d54fd-9ad3-7148-bd1b-f400ae1a89ef",
        "storage_key": "property/6767906449167338/019d54fd-9ad3-7148-bd1b-f400ae1a89ef.webp",
        "width": 2560,
        "height": 1536
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9947247984918018643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "color-me-crazy-salon",
      "poi_latitude": "34.0598567",
      "poi_longitude": "-86.76776149999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 256-887-1434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54fd-d5a7-76df-bd5b-bc5d344b94fc",
        "storage_key": "property/6767906449167338/019d54fd-d5a7-76df-bd5b-bc5d344b94fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgcjsuA63iYgRUzrC6Va5C4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9054f8c5-20cc-47a8-bdff-bf45aadd51ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Cross Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2321 Co Rd 490, Hanceville, AL 35077, USA",
      "poi_short_description": "Popular 18-hole course at a club featuring greens and fairways in good condition.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-a91d-71af-a738-4dafdad17377.webp",
      "poi_featured_image_media": {
        "alt_text": "A picturesque golf course with a winding path under a clear blue sky with scattered clouds.",
        "public_id": "019d54fd-a91d-71af-a738-4dafdad17377",
        "storage_key": "property/6767906449167338/019d54fd-a91d-71af-a738-4dafdad17377.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.crosscreekcullman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16157998885547252782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cross-creek-golf-course",
      "poi_latitude": "34.1072012",
      "poi_longitude": "-86.83080559999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 256-739-2386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d569-76bd-839a-a199960ebd12.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon representing someone playing soccer",
        "public_id": "019d54fd-d569-76bd-839a-a199960ebd12",
        "storage_key": "property/6767906449167338/019d54fd-d569-76bd-839a-a199960ebd12.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWiU3Pm1iYgRLpwzrmC-POA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_911683ab-aa75-49d5-a492-94bbcdf46d4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "CW Day Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Michelle St NW, Hanceville, AL 35077, USA",
      "poi_short_description": "Public park featuring a pool, playground, baseball field, picnic tables, and pavilions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-a925-77ae-92da-7c8cfb129cf8.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures for children.",
        "public_id": "019d54fd-a925-77ae-92da-7c8cfb129cf8",
        "storage_key": "property/6767906449167338/019d54fd-a925-77ae-92da-7c8cfb129cf8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cityofhanceville.net/parkrec",
      "poi_directions_map_url": "https://maps.google.com/?cid=15119198854571855553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cw-day-park",
      "poi_latitude": "34.0628603",
      "poi_longitude": "-86.7763901",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree icon.",
        "public_id": "019d54fd-d58c-7614-856a-cff2651592d8",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Qrlzga3iYgRwY4_10Av0tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b98d592-d707-4391-b4a3-d73e2f607156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Veterans Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "503 Park St, Hanceville, AL 35077, USA",
      "poi_short_description": "Relaxing park featuring a dog area, a playground, and a loop trail, along with equipment for workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-b34e-767e-8efc-8fd61f754c0f.webp",
      "poi_featured_image_media": {
        "alt_text": "A serene pond with a fountain in the center, surrounded by lush green trees.",
        "public_id": "019d54fd-b34e-767e-8efc-8fd61f754c0f",
        "storage_key": "property/6767906449167338/019d54fd-b34e-767e-8efc-8fd61f754c0f.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2893291250861297366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-memorial-park",
      "poi_latitude": "34.0566298",
      "poi_longitude": "-86.7632168",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 256-352-9830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree icon.",
        "public_id": "019d54fd-d58c-7614-856a-cff2651592d8",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2gmed-3iYgR1k5VNxAJJyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28e3a449-e251-4948-b321-fa5e169ddf54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Garden City River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1310 Old Highway 31 South, Garden City, AL 35070, USA",
      "poi_short_description": "Park and camping destination known for its tranquil vibe, plus waterfalls, hiking trails and canoes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-b59f-71f7-a70a-cbdfc6b26d4c.webp",
      "poi_featured_image_media": {
        "alt_text": "River with a bridge and trees",
        "public_id": "019d54fd-b59f-71f7-a70a-cbdfc6b26d4c",
        "storage_key": "property/6767906449167338/019d54fd-b59f-71f7-a70a-cbdfc6b26d4c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://gardencityal.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12784569484893085710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "garden-city-river-park",
      "poi_latitude": "33.9994012",
      "poi_longitude": "-86.7466544",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 256-352-5408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree icon.",
        "public_id": "019d54fd-d58c-7614-856a-cff2651592d8",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9eLOGaKwiYgRDuBZATbqa7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d485841-7785-42cd-9a06-f0861bd1881a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "Perry Ray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-c1e3-735c-95c9-b6f61f9a2b1c.webp",
      "poi_featured_image_media": {
        "alt_text": "A black dog walks near a rock formation in a wooded area with a small bridge over a stream.",
        "public_id": "019d54fd-c1e3-735c-95c9-b6f61f9a2b1c",
        "storage_key": "property/6767906449167338/019d54fd-c1e3-735c-95c9-b6f61f9a2b1c.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://dodgecitytown.com/facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8467720884380667241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "perry-ray-park",
      "poi_latitude": "34.0499865",
      "poi_longitude": "-86.86805930000001",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a stylized Christmas tree icon.",
        "public_id": "019d54fd-d58c-7614-856a-cff2651592d8",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-cff2651592d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4ZKmvO0iYgRaY2qykdjg3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_911c4901-929c-4021-a135-8d27ff261c0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "DODGE CITY TOWN HALL",
      "poi_type": "Major Employers & Offices",
      "poi_address": "130 Howard Cir, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dodgecitytown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036055337287437524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dodge-city-town-hall",
      "poi_latitude": "34.049208",
      "poi_longitude": "-86.8707415",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 256-287-0364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54fd-d58c-7614-856a-d236c54fba1c",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzRy9PK0iYgR1ExmnsDNhW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_79fc13af-b209-4956-85a7-0fcce7d7a3de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "City of Hanceville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "112 Main St SE, Hanceville, AL 35077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-b3db-75e8-904e-d3c1d4b90269.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding businesses at sunset.",
        "public_id": "019d54fd-b3db-75e8-904e-d3c1d4b90269",
        "storage_key": "property/6767906449167338/019d54fd-b3db-75e8-904e-d3c1d4b90269.webp",
        "width": 960,
        "height": 719
      },
      "poi_business_url": "http://www.cityofhanceville.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6680938448235388495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-hanceville",
      "poi_latitude": "34.0587171",
      "poi_longitude": "-86.767129",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 256-352-9830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54fd-d58c-7614-856a-d236c54fba1c",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78IQk2G3iYgRT95RHR92t1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c86c1eb4-322c-4ef7-8615-55e1804d42a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "poi_name": "City of Good Hope",
      "poi_type": "Major Employers & Offices",
      "poi_address": "135 Municipal Dr, Cullman, AL 35057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-b555-75df-a69e-746f7bd31e17.webp",
      "poi_featured_image_media": {
        "alt_text": "Baseball field with stadium lights and unique cloud formations overhead.",
        "public_id": "019d54fd-b555-75df-a69e-746f7bd31e17",
        "storage_key": "property/6767906449167338/019d54fd-b555-75df-a69e-746f7bd31e17.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.goodhopeal.com/?fbclid=IwAR0t2icvGnUSQUlwfUT7DiRs-4sBJ95TVyfE8p-Xzgb9HqrpQvKXINAf4yE",
      "poi_directions_map_url": "https://maps.google.com/?cid=5464319462091336049&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-good-hope",
      "poi_latitude": "34.1090086",
      "poi_longitude": "-86.86706910000001",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 256-739-3757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54fd-d58c-7614-856a-d236c54fba1c",
        "storage_key": "property/6767906449167338/019d54fd-d58c-7614-856a-d236c54fba1c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl96HH3y1iYgRcSk1fZkp1Us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2ce4119cbc13b4e1e94f4f3b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_d27cf7cf908550a9a25a62aa",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e9774ace440b3db80b97d8d7",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5e24970e4c03944b4e261faa",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_715d977a8862f1e963d1aee0",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_53e2f27d-7884-4409-9167-a2db5080dc65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Wendy Smith",
      "text": "Amazing team! Alyse McGill in leasing is professional, friendly, and very helpful. Michael and Caleb McAvoy in maintenance are quick, reliable, and always do great work. Jerry Davis keeps the grounds clean and looking great. It’s clear everyone takes pride in their job. Highly recommend!",
      "date": "2026-01-20",
      "title": ""
    },
    {
      "id": "custom_6b74a95b-7f5f-4e06-9cf3-4c56946fc340",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Cadance Avery Austin",
      "text": "Beautiful apartments and super close to Cullman city. DoorDash goes crazy here. Clean facilities and has great infrastructure for walking or running or hanging out outside. Affordable comparatively to other places especially considering the quality of the apartments. 10/10 recommend",
      "date": "2025-10-27",
      "title": ""
    },
    {
      "id": "custom_cbcf9b53-f0e7-4838-b1ca-ad232abb39e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Talia Ray",
      "text": "The best leasing consultant ever! Allie knows her stuff and is always available to ask a question!  Michael always gets the maintenance request done as soon as time allows!! ! Michael is always helpful when it comes to any questions!",
      "date": "2026-01-20",
      "title": ""
    },
    {
      "id": "custom_62d225a0-88d6-4fdd-a990-5a5c43ca8a23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Cassie Wilson",
      "text": "I have lived here for 4 years and the staff is very attentive. The maintenance staff always goes above and beyond to keep everything looking nice and all systems working as they should. 10 out of 10 recommend!",
      "date": "2026-07-06",
      "title": ""
    },
    {
      "id": "custom_1d55f05e-c9ca-48f8-b7f7-35ab1c436bf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Calamity",
      "text": "Ms. Ellis was very nice and informative! Especially when I was calling about pricing and the process of being approved for the apartments. She made sure to walk me through everything and patiently answered all my questions. Good people here 😊",
      "date": "2026-07-06",
      "title": ""
    },
    {
      "id": "custom_1e2c44b9-5708-4ae7-88c5-8e2dc67f171d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Wendy Smith",
      "text": "Amazing team! Alyse McGill in leasing is professional, friendly, and very helpful. Michael and Caleb McAvoy in maintenance are quick, reliable, and always do great work. Jerry Davis keeps the grounds clean and looking great. It’s clear everyone takes pride in their job. Highly recommend!",
      "date": "2026-01-20",
      "title": ""
    },
    {
      "id": "custom_7ced30af-d854-4901-b996-6617da4690a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "rating": "5.0",
      "name": "Tim Perkins",
      "text": "This place is amazing. The location is superb and the manager is excellent. Every one has their ups and downs, but as far as convenience and intellectual know how you won’t find another place in this area like them.",
      "date": "2026-07-06",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_095284b9c46b9c58f194e242",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167338/019f0ce3-b3bf-7108-a0c2-67a51f29f17b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f0ce3-b3bf-7108-a0c2-67a51f29f17b",
        "storage_key": "property/6767906449167338/019f0ce3-b3bf-7108-a0c2-67a51f29f17b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 615 sq ft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Jxp1Sc9ABE5"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-d665-71ab-9a15-6551f27d72d9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Pavilion at College Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338"
    },
    {
      "lead_collector_id": "019db23f-d6da-76f9-898a-417f182be6b5",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Pavilion at College Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338"
    },
    {
      "lead_collector_id": "019db23f-d750-76fa-83d2-9ee2c5ad8184",
      "lead_source": "LANDING_PAGE",
      "name": "The Pavilion at College Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "apartments-with-pet-park-hanceville-al",
      "search_query": "apartments with pet park in Hanceville AL",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Hanceville, AL",
      "h2_subtitle": "Discover our apartments with pet park in Hanceville, AL. Ideal for pet owners seeking a community that caters to furry friends.",
      "page_copy": "At The Pavilion, we understand that pets are part of the family. That's why our apartments in Hanceville, AL, feature not only ample living spaces but also a well-maintained pet park where your furry friends can frolic freely. Located within Cullman County, The Pavilion offers double closets, washer and dryer connections, and a dedicated laundry facility to make everyday living convenient and enjoyable.\n\nOur spacious living spaces include all-black appliances, ensuring modern comforts, and the pet park adds an extra layer of community-friendly living. With plenty of closet space, you'll find that our apartments are as practical as they are pet-friendly. Explore the vibrant lifestyle at The Pavilion, where you and your pets can thrive in a welcoming environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hanceville Pet-Friendly Apartments",
      "seo_description": "Explore pet-friendly apartments in Hanceville, AL with a pet park, double closets, and modern amenities at The Pavilion.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "spacious-floor-plan-apartments-cullman-county",
      "search_query": "spacious floor plan apartments in Cullman County",
      "category": "Amenity",
      "h1_title": "Spacious Apartments in Cullman County",
      "h2_subtitle": "Explore our spacious floor plan apartments in Cullman County. Designed to give you comfort and ample space.",
      "page_copy": "The Pavilion offers spacious floor plan apartments in the heart of Cullman County, perfect for those seeking comfort and ample space. Each unit comes with double closets and washer and dryer connections, providing modern living conveniences in stunning spacious settings. Our community is designed for residents who value both style and functionality; all-black appliances contribute to the contemporary feel, while a generous layout allows you to arrange your living space with ease.\n\nNot only do you get extensive closet space, but The Pavilion also boasts a laundry facility and a nearby pet park for the ultimate convenience. Ideal for professionals, and pet lovers alike, our Hanceville, AL, location ensures you have access to the best in apartment living. Experience the freedom of modern living in our expansive floor plans at The Pavilion in Cullman County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans in Cullman County",
      "seo_description": "Discover spacious floor plan apartments in Cullman County with ample closets and modern amenities at The Pavilion. Live comfortably.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "apartments-near-campus-hanceville-35077",
      "search_query": "apartments near campus in Hanceville 35077",
      "category": "Amenity",
      "h1_title": "Apartments Near Campus in Hanceville",
      "h2_subtitle": "Conveniently located apartments near campus in Hanceville, 35077. Ideal for students pursuing a balanced lifestyle.",
      "page_copy": "Located just minutes away from campus in Hanceville, The Pavilion offers perfect living options for students and faculty. Our apartments in the 35077 area are designed to provide convenience and comfort, featuring modern amenities like washer and dryer connections and all-black appliances. Ideal for those who value both proximity and practicality, our community ensures you can focus on your studies while enjoying a pleasant living environment.\n\nOur apartment homes come with ample closet space, and double closets add to the storage convenience. Plus, residents have access to a laundry facility, making daily chores a breeze. Situated in the vibrant area of Hanceville, you'll find The Pavilion an ideal choice for campus-goers seeking balance between academic life and modern apartment perks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hanceville Apartments Near Campus",
      "seo_description": "Find apartments near campus in Hanceville, 35077 with modern amenities and ample storage at The Pavilion. Perfectly suited for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-hanceville",
      "search_query": "apartments with in-unit laundry in Hanceville",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Hanceville",
      "h2_subtitle": "Discover apartments with in-unit laundry in Hanceville, offering convenience and comfort for a modern lifestyle.",
      "page_copy": "At The Pavilion in Hanceville, enjoy the ultimate convenience with our apartments featuring in-unit laundry connections. Perfectly situated in Cullman County, our community is designed to cater to your everyday needs, making it easy to balance home and work life. Each apartment includes modern all-black appliances and generous closet space, ensuring a comfortable and functional living area.\n\nOur residents appreciate the ease of doing laundry at home, coupled with the additional perk of our on-site laundry facility if needed. With double closets for maximum storage and a pet-friendly environment, The Pavilion offers a lifestyle where comfort meets practicality. Experience the difference of in-unit laundry in our Hanceville apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Hanceville",
      "seo_description": "Find Hanceville apartments with in-unit laundry, double closets, and modern amenities at The Pavilion, tailored for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "spacious-floor-plan-apartments-hanceville-al",
      "search_query": "spacious floor plan apartments in Hanceville AL",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plan Apartments in Hanceville",
      "h2_subtitle": "Our spacious floor plan apartments in Hanceville, AL are crafted for comfort and style, providing the perfect living space.",
      "page_copy": "The Pavilion in Hanceville, AL invites you to explore our spacious floor plan apartments designed for those who appreciate comfort and elegance. With generous living areas, these apartments provide the perfect backdrop for your lifestyle. Featuring all-black appliances and washer and dryer connections, each unit is thoughtfully equipped for modern needs.\n\nAmple closet space, including double closets, ensures all your storage needs are met, while residents enjoy the convenience of an on-site laundry facility. Located in the welcoming community of Hanceville, our apartments are ideal for individuals and those alike who want the luxury of wide-open spaces without sacrificing amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments in Hanceville, AL",
      "seo_description": "Explore spacious floor plan apartments in Hanceville, AL with modern amenities and ample closets at The Pavilion.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-hanceville-al",
      "search_query": "1 bedroom apartments in Hanceville AL",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Hanceville, AL",
      "h2_subtitle": "Explore our 1 bedroom apartments in Hanceville, AL, where comfort meets convenience in beautifully designed living spaces.",
      "page_copy": "Welcome to The Pavilion, offering delightful 1 bedroom apartments in the heart of Hanceville, AL. Our apartments are thoughtfully designed to provide the ideal living experience, boasting modern features such as all-black appliances and washer and dryer connections. Each unit is crafted for both aesthetic appeal and practicality, ensuring you feel at home.\n\nIn addition to the spacious interior, our community offers ample closet space with double closets, perfect for maintaining an organized living environment. Whether you’re a student, professional, or retiree, our 1 bedroom apartments are perfectly suited to meet your needs while providing easy access to local amenities and vibrant community life in Hanceville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Hanceville, AL",
      "seo_description": "Discover 1 bedroom apartments in Hanceville, AL at The Pavilion with all-black appliances and ample storage designed for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-cullman-county",
      "search_query": "2 bedroom apartments near Cullman County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Cullman County",
      "h2_subtitle": "Discover the perfect 2 bedroom apartments near Cullman County, offering modern comforts and ample living space.",
      "page_copy": "The Pavilion is proud to offer spacious 2 bedroom apartments conveniently located near Cullman County. These apartments provide an ideal living space with modern amenities such as all-black appliances and washer and dryer connections, making household chores a breeze. Designed with comfort in mind, each unit ensures ample natural light and roomy interiors.\n\nResidents enjoy features like double closets and additional storage solutions, perfect for a tidy and organized living environment. Our community also provides an on-site laundry facility, adding to the list of conveniences. Experience the peace and comfort of living in a beautiful apartment setting while being close to the vibrant life surrounding Cullman County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Cullman County",
      "seo_description": "Find 2 bedroom apartments near Cullman County at The Pavilion, offering modern amenities and spacious living areas for a comfortable home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "3-bedroom-floorplans-35077",
      "search_query": "3 bedroom floorplans 35077",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floorplans in 35077",
      "h2_subtitle": "Explore our versatile 3 bedroom floorplans in the 35077 area, offering ample space and modern amenities for every lifestyle.",
      "page_copy": "At The Pavilion, located in the inviting community of Hanceville, AL, we offer expansive 3 bedroom floorplans designed to enhance your living experience. Each apartment features modern all-black appliances and convenient washer and dryer connections, ensuring your home perfectly balances style and function.\n\nOur spacious layouts include ample closet space with double closets, ideal for individuals seeking room to grow. An on-site laundry facility further complements the dynamic lifestyle offered here. Situated in the 35077 ZIP code, our 3 bedroom apartments are the perfect choice for those who desire comfort along with proximity to local conveniences and vibrant community life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floorplans in 35077",
      "seo_description": "Discover expansive 3 bedroom floorplans in 35077 at The Pavilion, featuring modern amenities and ample living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "apartments-near-wallace-state-community-college-hanceville",
      "search_query": "apartments near wallace state community college hanceville",
      "category": "School",
      "h1_title": "Apartments Near Wallace State Community College",
      "h2_subtitle": "Find ideal apartments near Wallace State Community College in Hanceville, designed with students and faculty in mind.",
      "page_copy": "Located just minutes from Wallace State Community College in Hanceville, The Pavilion offers the perfect apartments for students and faculty seeking convenience and comfort. Our community provides modern living spaces with features like all-black appliances and washer and dryer connections, ensuring a seamless living experience.\n\nResidents will appreciate the ample closet space, including double closets that offer generous storage solutions. With an on-site laundry facility, we make everyday chores simple and efficient. Nestled in a vibrant community, these apartments provide easy access to campus life while enjoying the serene setting of Hanceville. Choose The Pavilion for a blend of comfort and proximity to Wallace State.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wallace State Community College",
      "seo_description": "Find apartments near Wallace State Community College at The Pavilion, featuring modern amenities and convenient access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "apartments-near-cw-day-park-hanceville",
      "search_query": "apartments near CW Day Park Hanceville",
      "category": "Park",
      "h1_title": "Apartments Near CW Day Park, Hanceville",
      "h2_subtitle": "Discover the perfect living at The Pavilion, offering apartments near CW Day Park in Hanceville for those who love the outdoors.",
      "page_copy": "The Pavilion, situated near CW Day Park in Hanceville, offers an idyllic setting for those who enjoy both community living and outdoor adventures. Just steps away from the park, our apartments feature modern conveniences like all-black appliances and washer and dryer connections, complementing any lifestyle.\n\nWith generous amenities such as double closets and substantial closet space, you'll find organization easy in our spacious apartments. An on-site laundry facility enhances the convenience factor, making everyday living straightforward. Enjoy the proximity to CW Day Park and relish the balance of outdoor leisure with the comfort of home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near CW Day Park, Hanceville",
      "seo_description": "Find apartments near CW Day Park at The Pavilion, offering modern amenities and a serene setting perfect for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "veterans-memorial-park-close-by-apartments-cullman-county",
      "search_query": "Veterans Memorial Park close by apartments in Cullman County",
      "category": "Park",
      "h1_title": "Apartments Near Veterans Memorial Park",
      "h2_subtitle": "Enjoy living in Cullman County with apartments conveniently close to Veterans Memorial Park, perfect for leisure and relaxation.",
      "page_copy": "Experience the comfort of apartment living close to Veterans Memorial Park in Cullman County at The Pavilion. Our community is ideally situated to offer easy access to this serene park, making it an excellent choice for those who love outdoor activities. Our modern apartments are well-equipped with amenities like all-black appliances and washer dryer connections, designed for effortless living.\n\nInside our spacious homes, residents appreciate features like double closets and abundant closet space for optimal storage solutions. Additionally, a laundry facility on-site ensures convenience. Choose The Pavilion for an ideal blend of park-side tranquility and modern lifestyle in the heart of Cullman County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Veterans Memorial Park",
      "seo_description": "Discover apartments close to Veterans Memorial Park in Cullman County. The Pavilion offers modern living with convenient access to local green spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167338",
      "source": "custom",
      "page_item_url": "garden-city-river-park-nearby-apartments-35077",
      "search_query": "Garden City River Park nearby apartments 35077",
      "category": "Park",
      "h1_title": "Apartments Near Garden City River Park",
      "h2_subtitle": "Find your ideal home near Garden City River Park in the 35077 area, offering beautiful views and modern amenities.",
      "page_copy": "Nestled in the picturesque setting of the 35077 area, The Pavilion offers prime apartments near the tranquil Garden City River Park. Ideal for those who appreciate natural beauty and outdoor activities, our community provides easy access to the park's serene environment. Enjoy modern amenities, including all-black appliances and washer dryer connections, designed for contemporary living.\n\nOur apartments feature ample storage solutions with double closets and generous closet space, perfect for organizing your belongings. An on-site laundry facility further adds convenience to daily life. The Pavilion is the perfect choice for those seeking a balance of relaxation and modern amenities in proximity to Garden City River Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Garden City River Park",
      "seo_description": "Explore apartments in the 35077 area near Garden City River Park. The Pavilion offers modern amenities and stunning park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6079"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671070088"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TL4TK6RK"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "95401dbd11eff9eb"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "614512163"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "f96a8eeaecda269afd60"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a134f578-d0cb-11f0-a5a8-3bb9cf14c474"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/thepavilion/uploads/assets/untitled-video.4ef5acf5.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134f578-d0cb-11f0-a5a8-3bb9cf14c474/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IitjcDdjVzNjWW9hN2lqbDdyWVdMTFE9PSIsInZhbHVlIjoiWUdmNVhtTWpUUEFVczZibkdUS2Erdz09IiwibWFjIjoiZWRjZDg3MzMyZmRjNDM4NzMyMTIwMTQ0Y2ZkMWZkYjUwZGIwMzQzNzE0YmNjMjQwNjkxYzc1ZDdhZmI0ODM4NyJ9"
    }
  ],
  "custom_qb_id": "6079",
  "custom_repli_id": "11671070088",
  "custom_google_gtm_id": "GTM-TL4TK6RK",
  "custom_knock_community_id": "95401dbd11eff9eb",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "614512163",
  "custom_call_rail_account_hash": "f96a8eeaecda269afd60",
  "custom_eliseai_building_token": "a134f578-d0cb-11f0-a5a8-3bb9cf14c474",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/thepavilion/uploads/assets/untitled-video.4ef5acf5.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a134f578-d0cb-11f0-a5a8-3bb9cf14c474/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IitjcDdjVzNjWW9hN2lqbDdyWVdMTFE9PSIsInZhbHVlIjoiWUdmNVhtTWpUUEFVczZibkdUS2Erdz09IiwibWFjIjoiZWRjZDg3MzMyZmRjNDM4NzMyMTIwMTQ0Y2ZkMWZkYjUwZGIwMzQzNzE0YmNjMjQwNjkxYzc1ZDdhZmI0ODM4NyJ9",
  "custom_audioeye_site_id": "dfa20b14-043e-4d5f-92e1-6301353cb383",
  "custom_audioeye_site_hash": "931ea1a8f2f1cc387b26ade20edb806d"
};

export const generatedAt = '2026-10-01T17:22:55.049Z';
